import { render, staticRenderFns } from "./caixasMesasFiltrados.vue?vue&type=template&id=3c02a4a0&scoped=true&"
import script from "./caixasMesasFiltrados.vue?vue&type=script&lang=js&"
export * from "./caixasMesasFiltrados.vue?vue&type=script&lang=js&"
import style0 from "./caixasMesasFiltrados.vue?vue&type=style&index=0&id=3c02a4a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c02a4a0",
  null
  
)

export default component.exports